import React, { useState, useEffect } from 'react';

interface SendCodeButtonProps {
    onSendCode: () => Promise<void>;  // Function to handle sending the code
    initialTime: number;    // Optional initial countdown time in seconds (default: 60 seconds)
    startCountdown: boolean;  // Optional flag to start countdown immediately (default: false)
}

const SendCodeButton: React.FC<SendCodeButtonProps> = ({ onSendCode, initialTime, startCountdown }) => {
    const [timeLeft, setTimeLeft] = useState<number>(0); // Remaining time for countdown
    const [isSending, setIsSending] = useState<boolean>(false); // Button loading state

    useEffect(() => {
        console.log("Start countdown:", startCountdown);
        // Start countdown when component mounts or when startCountdown is updated
        if (startCountdown) {
            setTimeLeft(initialTime);
            console.log('Starting countdown', initialTime);
        }
    }, [startCountdown, initialTime]);

    useEffect(() => {
        let timer: NodeJS.Timeout;

        // Start countdown if timeLeft > 0
        if (timeLeft > 0) {
            timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);  // Decrease time every second
        }

        return () => {
            if (timer) clearTimeout(timer);  // Cleanup the timer when unmounted or countdown ends
        };
    }, [timeLeft]);

    const handleSendCode = async () => {
        setIsSending(true);  // Disable button while sending code
        setTimeLeft(initialTime);  // Reset countdown timer
        await onSendCode();  // Trigger the handler passed as prop
        setIsSending(false);  // Re-enable button after sending
    };

    return (
        <span className="send-code-wrapper">
            <button 
                className="send-code-button" 
                onClick={handleSendCode} 
                disabled={timeLeft > 0 || isSending}  // Disable if timer is running or during sending
            >
                {timeLeft > 0 ? `${timeLeft}s` : 'Send Again'}
            </button>
        </span>
    );
};

export default SendCodeButton;

